/**
 * @flow
 * @relayHash 27ef0b47e55c74692e9c7df77e89b377
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DeliverableFilesList_deliverable$ref = any;
export type DeliverableFilesTabQueryVariables = {|
  id: string
|};
export type DeliverableFilesTabQueryResponse = {|
  +deliverable: ?{|
    +$fragmentRefs: DeliverableFilesList_deliverable$ref
  |}
|};
export type DeliverableFilesTabQuery = {|
  variables: DeliverableFilesTabQueryVariables,
  response: DeliverableFilesTabQueryResponse,
|};
*/


/*
query DeliverableFilesTabQuery(
  $id: ID!
) {
  deliverable(id: $id) {
    ...DeliverableFilesList_deliverable
    id
  }
}

fragment DeliverableFilesList_deliverable on DeliverableNode {
  id
  finalFileMaxSize
  assignedStaff {
    user {
      id
    }
    id
  }
  assignedInternally {
    user {
      id
    }
    id
  }
  finalFiles(orderBy: "-created") {
    edges {
      node {
        id
        created
        fileName
        fileSize
        description
        fileUrl
        storageClass
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "user",
    "storageKey": null,
    "args": null,
    "concreteType": "UserNode",
    "plural": false,
    "selections": [
      (v2/*: any*/)
    ]
  },
  (v2/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeliverableFilesTabQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deliverable",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DeliverableNode",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DeliverableFilesList_deliverable",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DeliverableFilesTabQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deliverable",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DeliverableNode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "finalFileMaxSize",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "assignedStaff",
            "storageKey": null,
            "args": null,
            "concreteType": "StaffNode",
            "plural": false,
            "selections": (v3/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "assignedInternally",
            "storageKey": null,
            "args": null,
            "concreteType": "StaffNode",
            "plural": false,
            "selections": (v3/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "finalFiles",
            "storageKey": "finalFiles(orderBy:\"-created\")",
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": "-created"
              }
            ],
            "concreteType": "DeliverableFinalFileNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DeliverableFinalFileNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DeliverableFinalFileNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "created",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "fileName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "fileSize",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "description",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "fileUrl",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "storageClass",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "DeliverableFilesTabQuery",
    "id": null,
    "text": "query DeliverableFilesTabQuery(\n  $id: ID!\n) {\n  deliverable(id: $id) {\n    ...DeliverableFilesList_deliverable\n    id\n  }\n}\n\nfragment DeliverableFilesList_deliverable on DeliverableNode {\n  id\n  finalFileMaxSize\n  assignedStaff {\n    user {\n      id\n    }\n    id\n  }\n  assignedInternally {\n    user {\n      id\n    }\n    id\n  }\n  finalFiles(orderBy: \"-created\") {\n    edges {\n      node {\n        id\n        created\n        fileName\n        fileSize\n        description\n        fileUrl\n        storageClass\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'aab2acadc1b08cd0ce8c70531983c5a6';
module.exports = node;
